import { getLocalStorageItemAsString } from '@atlassian/search-common/local-storage';

/**
 * Retrieves the session ID directly from the local storage, which is set by the analytics-web-client.
 * It's a short-term solution that relies on two main assumptions:
 *  1. The local storage key for the session ID will not change.
 *  2. The session ID in the storage is kept up to date at all times.
 *     This is valid because getCurrentSessionId() from the analytics-web-client ensures
 *     a fresh value every time the session ID is retrieved (which is very frequent).
 */
export const getSessionIdFromLocalStorage: () => string | undefined = () => {
	// The key is defined in packages/atlassian-analytics-pipeline/analytics-web-client/src/sessionTracking.ts.
	const LOCAL_STORAGE_KEY = 'awc.session.id';

	try {
		return getLocalStorageItemAsString(LOCAL_STORAGE_KEY) ?? undefined;
	} catch (error) {
		return undefined;
	}
};
